module.exports = __webpack_public_path__ + "static/media/Icon_4.cc39e274.svg";